/* eslint-env browser */
import query from 'component-query';
import defaults from 'modules/metas-defaults';
import { merge } from 'lodash';

export default function metas(obj) {
  const _defaults = merge({}, defaults);
  const _obj = merge(_defaults, obj);

  for (const prop in _obj) {
    let meta = query(`meta[name=${prop}]`);
    const title = query('title');

    if (!_obj.hasOwnProperty(prop)) continue;
    if (!meta) meta = document.createElement('meta');
    meta.setAttribute('name', prop);
    meta.setAttribute('content', _obj[prop]);

    // asume title exists, and insert after it
    if (!meta.parentNode) {
      after(title, meta);
    }
  }
}

function after(node, meta) {
  if (!node.nextSibling) return node.parentNode.appendChild(meta);
  node.parentNode.insertBefore(meta, node.nextSibling);
}



// WEBPACK FOOTER //
// ./src/modules/metas/metas.js